import heroImage from "../assets/emisaathi-hero.png";
import "./container.css";
import "./Hero.css";

const STATS = [
  { value: "₹850Cr+", label: "Debt Consolidated" },
  { value: "1,20,000+", label: "Users Assisted" },
  { value: "4.8★", label: "Customer Satisfaction" },
  { value: "24x7", label: "Digital Access" },
];

const Hero = () => {
  return (
    <section className="hero-section w-full">
      <div className="hero-grid container-8xl">
        {/* Left: copy */}
        <div className="hero-content">
          <span
            className="hero-badge-pill inline-flex items-center gap-2 font-['Inter'] font-[500]"
            style={{
              borderRadius: "96px",
              background: "#FFF",
              boxShadow: "0 1px 2px 0 rgba(35, 39, 46, 0.08)",
              color: "#000",
            }}
          >
            <span
              className="inline-flex h-4 w-4 items-center justify-center rounded-full shrink-0"
              style={{ background: "#032799" }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <g clipPath="url(#hero-badge-sparkle-clip)">
                  <path
                    d="M0.5 5.5C3.26143 5.5 5.5 3.26143 5.5 0.5H6.5C6.5 3.26143 8.7386 5.5 11.5 5.5V6.5C8.7386 6.5 6.5 8.7386 6.5 11.5H5.5C5.5 8.7386 3.26143 6.5 0.5 6.5V5.5Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="hero-badge-sparkle-clip">
                    <rect width="12" height="12" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </span>
            Simplify Your Debt, Take Back Control
          </span>

          <h1 className="hero-headline font-['Inter'] font-[500]">
            <span style={{ color: "#032799" }}>Get Out of </span>
            <span style={{ color: "#F94C09" }}>Debt,</span>
            <br />
            <span className="hero-line-nowrap" style={{ color: "#0B0B0F" }}>
              Without the Overwhelm
            </span>
          </h1>

          {/* Gradient sits only behind this block */}
          <div className="hero-orange-glow w-full flex flex-col items-start gap-5">
            <div className="hero-orange-glow__blob" aria-hidden="true" />

            <div className="relative z-10 flex flex-col items-start gap-5">
              <p className="hero-paragraph font-['Inter'] font-[400]" style={{ color: "#1F2937", fontStyle: "normal" }}>
                Transform multiple high-interest debts into one simple, lower
                payment. Save money, reduce stress, and take control of your
                financial future.
              </p>

              <span
                className="hero-tagline font-['Plus_Jakarta_Sans'] font-[400] flex items-center gap-2"
                style={{ color: "#030712" }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" className="shrink-0">
                  <mask id="hero-tagline-rupee-mask" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                    <rect width="20" height="20" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#hero-tagline-rupee-mask)">
                    <path
                      d="M11.5738 17.125C10.8911 17.125 10.3401 16.9062 9.92075 16.4687C9.50141 16.0312 9.29175 15.4765 9.29175 14.8045C9.29175 14.3237 9.40339 13.8552 9.62669 13.399C9.84998 12.9428 10.1643 12.5297 10.5698 12.1595C10.9752 11.7893 11.4565 11.481 12.0137 11.2348C12.5709 10.9885 13.1833 10.8349 13.851 10.774C13.788 9.98344 13.624 9.40678 13.3591 9.04406C13.0941 8.68135 12.6988 8.5 12.1732 8.5C11.5001 8.5 10.8777 8.75908 10.3062 9.27725C9.7346 9.7954 9.15821 10.4022 8.577 11.0977C7.91033 11.9087 7.30483 12.5673 6.7605 13.0737C6.21617 13.5801 5.60425 13.8333 4.92477 13.8333C4.32327 13.8333 3.83822 13.621 3.46962 13.1963C3.10104 12.7716 2.91675 12.2126 2.91675 11.5192C2.91675 10.7404 3.09864 9.98344 3.46241 9.24839C3.82619 8.51335 4.26877 7.78044 4.79014 7.04966C5.09356 6.61378 5.34864 6.21207 5.55537 5.84454C5.7621 5.47703 5.86546 5.14744 5.86546 4.85577C5.86546 4.65171 5.81872 4.50668 5.72525 4.42067C5.63176 4.33467 5.50222 4.29167 5.33662 4.29167C5.14432 4.29167 4.93598 4.35978 4.71162 4.496C4.48726 4.63222 4.23619 4.85792 3.95841 5.17308L3.077 4.29167C3.45735 3.86751 3.83662 3.55315 4.21483 3.34856C4.59303 3.14397 4.96696 3.04167 5.33662 3.04167C5.86119 3.04167 6.28881 3.21127 6.61948 3.55048C6.95014 3.88969 7.11548 4.32158 7.11548 4.84614C7.11548 5.31303 6.98193 5.79942 6.71483 6.30529C6.44773 6.81117 6.11921 7.34402 5.72925 7.90385C5.29762 8.52564 4.9293 9.13194 4.62429 9.72275C4.31926 10.3136 4.16675 10.9012 4.16675 11.4856C4.16675 11.8499 4.23165 12.1239 4.36146 12.3077C4.49126 12.4915 4.67903 12.5833 4.92477 12.5833C5.3051 12.5833 5.69265 12.3876 6.08741 11.996C6.48218 11.6044 6.97069 11.0625 7.55296 10.3702C8.23565 9.55288 8.94185 8.82852 9.67156 8.1971C10.4013 7.5657 11.2351 7.25 12.1732 7.25C13.0717 7.25 13.7722 7.56677 14.2749 8.20031C14.7776 8.83387 15.053 9.68376 15.101 10.75H17.0834V12H15.101C15.0177 13.4893 14.6694 14.7158 14.0562 15.6795C13.4429 16.6432 12.6155 17.125 11.5738 17.125ZM11.5834 15.875C12.2319 15.875 12.7584 15.5099 13.1627 14.7796C13.5671 14.0494 13.7949 13.1341 13.8462 12.0337C12.9189 12.1213 12.1363 12.442 11.4985 12.996C10.8607 13.5499 10.5417 14.1464 10.5417 14.7852C10.5417 15.1293 10.6374 15.3969 10.8286 15.5881C11.0199 15.7794 11.2715 15.875 11.5834 15.875Z"
                      fill="#030712"
                    />
                  </g>
                </svg>
                A Smarter Way to Manage Your Debt.
              </span>

              <a
                href={import.meta.env.VITE_WEBSITE_LINK}
                target="_blank"
                rel="noreferrer"
                className="hero-cta-btn inline-flex items-center justify-center gap-2 font-['Inter'] font-[500] text-white mt-2 transition-transform hover:scale-105"
                style={{
                  borderRadius: "12px",
                  background:
                    "linear-gradient(0deg, #032799 0%, #032799 100%), #283AAA",
                  boxShadow:
                    "0 4px 6px -1px rgba(0, 0, 0, 0.10), 0 2px 4px -2px rgba(0, 0, 0, 0.10)",
                }}
              >
                Apply Now
                <span aria-hidden="true">→</span>
              </a>
            </div>
          </div>
        </div>

        {/* Right: visual */}
        <div className="hero-visual relative flex justify-center md:justify-end">
          <img
            src={heroImage}
            alt="EMI Saathi customer managing debt"
            className="hero-visual-image"
          />
        </div>
      </div>

      {/* Stats row */}
      <div className="hero-stats container-8xl">
        {STATS.map((stat) => (
          <div key={stat.label} className="flex flex-col items-center text-center gap-1">
            <span
              className="hero-stat-value font-['Funnel_Display'] font-[600]"
              style={{ color: "#032799", fontStyle: "normal" }}
            >
              {stat.value}
            </span>
            <span
              className="hero-stat-label font-['Plus_Jakarta_Sans'] font-[500]"
              style={{ color: "#032799", fontStyle: "normal" }}
            >
              {stat.label}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Hero;
